import { useClassName } from './useClassName';
import { styleRule } from './styleRule';
import { LooseProps, splitProps } from './props';

export function List(props: LooseProps) {
  const { sx, className, children, ...rest } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName(
    [{ listStyle: 'none', margin: 0, padding: '8px 0', ...system }, sx],
    undefined,
    className,
  );
  return (
    <>
      {styleRule(styleId, css)}
      <ul {...dom} className={resolvedClass}>
        {children}
      </ul>
    </>
  );
}

export function ListItem(props: LooseProps) {
  const { sx, className, children, disablePadding, ...rest } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName(
    [{ display: 'block', padding: disablePadding ? 0 : '8px 16px', ...system }, sx],
    undefined,
    className,
  );
  return (
    <>
      {styleRule(styleId, css)}
      <li {...dom} className={resolvedClass}>
        {children}
      </li>
    </>
  );
}

export function ListItemButton(props: LooseProps) {
  const { sx, className, children, ...rest } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName(
    [
      {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        textAlign: 'left',
        padding: '8px 16px',
        border: 'none',
        background: 'transparent',
        color: 'inherit',
        cursor: 'pointer',
        font: 'inherit',
        borderRadius: '4px',
        '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.08)' },
        ...system,
      },
      sx,
    ],
    undefined,
    className,
  );
  return (
    <>
      {styleRule(styleId, css)}
      <button {...dom} type="button" className={resolvedClass}>
        {children}
      </button>
    </>
  );
}

export function ListItemIcon(props: LooseProps) {
  const { sx, className, children, ...rest } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName(
    [
      {
        display: 'inline-flex',
        minWidth: '56px',
        color: 'inherit',
        flexShrink: 0,
        ...system,
      },
      sx,
    ],
    undefined,
    className,
  );
  return (
    <>
      {styleRule(styleId, css)}
      <span {...dom} className={resolvedClass}>
        {children}
      </span>
    </>
  );
}

export function ListItemText(props: LooseProps) {
  const { sx, className, primary, secondary, children, ...rest } = props;
  const { system, dom } = splitProps(rest);
  const {
    className: resolvedClass,
    css,
    styleId,
  } = useClassName([{ ...system }, sx], undefined, className);
  return (
    <>
      {styleRule(styleId, css)}
      <span {...dom} className={resolvedClass}>
        {primary ?? children ?? secondary}
      </span>
    </>
  );
}
